export enum TabId {
    WhatYouGet = 'what-you-get',
    HowItWorks = 'how-it-works',
    ProductComparison = 'product-comparison',
    Faq = 'faq',
    Reviews = 'reviews',
}
